import { planningAPI } from "../../axios";

export const actions = {
    //ResearchIndex
    GetResearchIndeces(){
        return planningAPI.get(`ResearchIndex/All`);
    },
    CreateResearchIndex(context, data){
        return planningAPI.post(`ResearchIndex/Create`, data);
    },
    UpdateResearchIndex(context, data){
        return planningAPI.put(`ResearchIndex/${data.id}`, data);
    },
    DeleteResearchIndex(context, data){
        return planningAPI.delete(`ResearchIndex/${data}`);
    },
}